export default __webpack_public_path__ + "static/logo_slogan_blue-a312d28b57dccb23dda2d06352bdd45d.svg";